import { render, staticRenderFns } from "./CreateOrUpdateConversation.vue?vue&type=template&id=6dfeac1c"
import script from "./CreateOrUpdateConversation.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports